import { render } from "./Widget11.vue?vue&type=template&id=40839250&ts=true"
import script from "./Widget11.vue?vue&type=script&lang=ts"
export * from "./Widget11.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__